import Loader from "@/views/components/loader/Loader.vue"

export default {
  name: 'StatusViewer',
  components: {
    Loader
  },
  emits:["closed"],
  data() {
    return {
      Display: false,
      isMyStatus:false,
      loading:false,
      allUsers: this.$store.state.users,
      bsrlImg: this.$store.state.baseUrl+'images/',
      bsrlAudio: this.$store.state.baseUrl+'audios/',
      colors:this.$store.state.colors,
      users:[], // array users who has statuses
      currentUserIndex:0,
      currentStatusIndex: 0,
      isPlaying: false,
      audioElement: null,
      showLikesMenu: false,
      showOptionsMenu: false, // ADD THIS
      isPaused: false, // ADD THIS
      pauseStartTime: null,
      pauseResumeTime: null,
      elapsedTime: 0,
      remainingTime: 0,
      wasRecentlyPaused: false, // ADD THIS

      autoProgressTimer: null,
      progressDuration: 5, // Default 5 seconds
      // User information
      user: {
        username: 'LeMoqhamtier',
        avatar: require('./img/profile.svg')
      },
      // One person's multiple statuses
      statuses: [{vue:[],likes:[]}]
    }
  },
  computed: {
    currentStatus() {
      const status = this.statuses[this.currentStatusIndex];
      if(status.userId !== this.$store.state.user.uid) this.seeStatus(status) // can't see my own status
      return status
    },
    currentStatusLiked() {
      const status = this.statuses[this.currentStatusIndex];
      const like = status.likes?.find(lk => lk.userId === this.$store.state.user.uid)
      return !!like
    },
    totalStatuses() {
      return this.statuses.length;
    },
    hasText() {
      return !!this.currentStatus.text;
    },
    hasImage() {
      return !!this.currentStatus.img;
    },
    hasAudio() {
      return !!this.currentStatus.audio;
    }
  },
  watch: {
    currentStatusIndex() {
      if(!this.currentStatus._id) return // if there is no status selected
      this.startAutoProgress();
    },
    showOptionsMenu(isOpen) {
      if (isOpen) {
        // Pause when menu opens
        this.pauseForMenu();
      } else {
        // Resume when menu closes
        this.resumeFromMenu();
      }
    },
    showLikesMenu(isOpen) {
      if (isOpen) {
        // Pause when likes list opens
        this.pauseForMenu();
      } else {
        // Resume when likes list closes
        this.resumeFromMenu();
      }
    }
  },
  methods: {
    close () {
      this.stopAudio()
      this.clearAutoProgress()
      this.statuses = [{vue:[],likes:[]}]
      this.currentStatusIndex = 0
      this.Display = false
      this.$emit('closed')
    },
    showForOneUser(users,status) {
      this.users = users
      this.currentUserIndex = 0
      const user = users[0]
      this.isMyStatus = user.uid === this.$store.state.user.uid
      this.user.username = user.name
      this.user.avatar = user.profilImgMini1
      this.currentStatusIndex = 0
      let statuses = status
      if(!statuses?.length > 0) {
        console.log('Error no status')
        return
      }
      this.statuses = statuses;
      this.Display = true;
      this.startAutoProgress();
    },
    show(users,index) {
      this.users = users
      this.currentUserIndex = index
      const user = users[index]
      this.isMyStatus = user.uid === this.$store.state.user.uid
      this.user.username = user.name
      this.user.avatar = user.avatar
      this.currentStatusIndex = 0
      const allStatus = this.$store.state.status
      let statuses = allStatus[user.uid]
      if(!statuses?.length > 0) {
        console.log('Error no status')
        return
      }
      this.statuses = statuses;
      this.Display = true;
      this.startAutoProgress();
    },
    showOptions() {
       this.toggleOptionsMenu();
      console.log('Show options');
    },
    toggleLikesList() {
      this.showLikesMenu = !this.showLikesMenu;
    },
    previousStatus() {
      this.stopAudio();
      this.clearAutoProgress();
      
      if (this.currentStatusIndex > 0) {
        this.currentStatusIndex--;
      } 
      else if(this.currentUserIndex > 0) this.show(this.users,this.currentUserIndex-1)
    },
    nextStatus() {
      this.stopAudio();
      this.clearAutoProgress();
      
      if (this.currentStatusIndex < this.statuses.length - 1) {
        this.currentStatusIndex++;
      }
      else if(this.currentUserIndex < this.users.length - 1) this.show(this.users,this.currentUserIndex+1)
    },
    // Update startAutoProgress to reset elapsed time:
    startAutoProgress() {
      this.clearAutoProgress();
      this.elapsedTime = 0;
      this.remainingTime = 0;
      this.wasRecentlyPaused = false; // ADD THIS
      
      if (this.hasAudio) {
        // For audio status, play audio and wait for it to end
        this.playAudio();
      } else {
        // For non-audio status, auto-advance after 5 seconds
        this.progressDuration = 5;
        this.pauseStartTime = Date.now();
        this.autoProgressTimer = setTimeout(() => {
          this.nextStatus();
        }, 5000);
      }
    },
    // Update clearAutoProgress method:
    clearAutoProgress() {
      if (this.autoProgressTimer) {
        clearTimeout(this.autoProgressTimer);
        this.autoProgressTimer = null;
      }
      this.elapsedTime = 0;
      this.remainingTime = 0;
      this.isPaused = false;
    },
    toggleAudio() {
      if (!this.currentStatus.audio) return;

      if (this.isPlaying) {
        this.pauseAudio();
      } else {
        this.playAudio();
      }
    },
    playAudio() {
      if (!this.currentStatus.audio) return;

      this.stopAudio();
      
      this.audioElement = new Audio();
      this.audioElement.src = this.bsrlAudio + this.currentStatus.audio;
      
      this.audioElement.addEventListener('ended', () => {
        this.isPlaying = false;
        // Auto-advance to next status when audio ends
        this.nextStatus();
      });

      this.audioElement.addEventListener('error', (e) => {
        console.error('Audio error:', e);
        this.isPlaying = false;
        // If audio fails, just advance after 5 seconds
        this.progressDuration = 5;
        this.autoProgressTimer = setTimeout(() => {
          this.nextStatus();
        }, 5000);
      });

      this.audioElement.addEventListener('loadedmetadata', () => {
        // Set progress duration to audio duration
        this.progressDuration = this.audioElement.duration;
      });

      const playPromise = this.audioElement.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.isPlaying = true;
          })
          .catch(err => {
            console.error('Playback error:', err);
            this.isPlaying = false;
          });
      }
    },
    pauseAudio() {
      if (this.audioElement) {
        this.audioElement.pause();
        this.isPlaying = false;
      }
    },
    stopAudio() {
      if (this.audioElement) {
        this.audioElement.pause();
        this.audioElement.currentTime = 0;
        this.audioElement = null;
        this.isPlaying = false;
      }
    },
    formatNumber(num) {
      if(!num) return 0
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k';
      }
      return num.toString();
    },
    getWaveStyle(index) {
      const height = Math.random() * 60 + 20;
      const delay = index * 0.05;
      return {
        height: `${height}%`,
        animationDelay: `${delay}s`
      };
    },
    getMiniWaveStyle(index) {
      const height = Math.random() * 80 + 20;
      const delay = index * 0.03;
      return {
        height: `${height}%`,
        animationDelay: `${delay}s`
      };
    },
    formatRelativeDate(date) {
      if(!date) return
      const now = new Date();
      const inputDate = new Date(date);

      // Reset time for comparison
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      const inputDay = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate()
      );

      const timeString = inputDate.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });

      if (inputDay.getTime() === today.getTime()) {
        return `Today, ${timeString}`;
      }

      if (inputDay.getTime() === yesterday.getTime()) {
        return `Yesterday, ${timeString}`;
      }

      // Fallback for older dates
      const dateString = inputDate.toLocaleDateString([], {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });

      return `${dateString}, ${timeString}`;
    },
    async seeStatus(status) {

      if(!status._id) return // status non existing
      const vus = status.vue
      const vu = vus?.find(vu => vu.userId === this.$store.state.user.uid) // check i status already seen
      console.log(vu)
      if(vu) {console.log('deja vzue');return}
      try {
          status.vue?.push({userId:this.$store.state.user.uid,createdAt:new Date()})
          this.$store.commit('setUserStatuses',{uid:status.userId,statuses:this.statuses})
          const res = await this.$axios.post('status.php',{type:"seeStatus",statusId:status._id})
          console.log(res.data)
      } catch (e) {
        status.vue = vus
        this.$store.commit('setUserStatuses',{uid:status.userId,statuses:this.statuses})
        console.log (e.response?.data?.error || e.message);
      } 
    },
    async likeStatus(currentStatusIndex, type) {
      const status = this.statuses[currentStatusIndex];
      const likes = [...status.likes]
      try {
          if(type == "likeStatus") {
            status.likes?.push({userId:this.$store.state.user.uid,createdAt:new Date()})
          }
          else {
            status.likes = status.likes?.filter(lk => lk.userId !== this.$store.state.user.uid )
          }
          // updating status globally
          this.$store.commit('setUserStatuses',{uid:status.userId,statuses:this.statuses})
          // type ==> unlikeStatus or likeStatus
          const res = await this.$axios.post('status.php',{type:type, statusId:status._id})
          console.log(res.data)
      } catch (e) {
        // if it failed reset likes
        status.likes = likes
        this.$store.commit('setUserStatuses',{uid:status.userId,statuses:this.statuses})
        console.log(e.response?.data?.error || e.message);
      } 
    },
    // Add these new methods in your methods section:

toggleOptionsMenu() {
  this.showOptionsMenu = !this.showOptionsMenu;
},

async deleteStatus() {
  const status = this.currentStatus;
  if (!status._id) return;
  this.loading = true
  try {
    const res = await this.$axios.post('status.php',{type:"delete",id:status._id})
    console.log(res.data);
    
    // Remove status from local array
    this.statuses.splice(this.currentStatusIndex, 1);
    this.$store.commit('setUserStatuses', {uid: status.userId,statuses: this.statuses});
    
    // If no more statuses, close viewer
    if (this.statuses.length === 0) {
      this.close();
    } else {
      // Adjust index if needed
      if (this.currentStatusIndex >= this.statuses.length) {
        this.currentStatusIndex = this.statuses.length - 1;
      }
      this.startAutoProgress();
    }
    
    this.showOptionsMenu = false;
  } catch (e) {
    console.log(e.response?.data?.error || e.message);
  } finally { this.loading = false }
},
// Replace handlePauseStart:
handlePauseStart(event) {
  // Prevent triggering on navigation zones or buttons
  if (/* event.target.closest('.nav-zone') || */ 
      event.target.closest('button') ||
      event.target.closest('.likes-menu')) {
    return;
  }
  
  this.isPaused = true;
  this.wasRecentlyPaused = true;
  this.pauseStartTime = Date.now();
  
  // Pause auto progress timer for non-audio statuses
  if (this.autoProgressTimer && !this.hasAudio) {
    clearTimeout(this.autoProgressTimer);
  }
  
  // Pause audio if playing
  if (this.isPlaying && this.audioElement) {
    this.audioElement.pause();
  }
},

// Replace handlePauseEnd:
handlePauseEnd(event) {
  if (!this.isPaused) return;
  
  this.isPaused = false;
  
  // Calculate how long we were paused
  const lastResumeTime = this.pauseResumeTime ? this.pauseResumeTime : 0
  this.pauseResumeTime = Date.now()
  const pauseDuration = this.pauseResumeTime - this.pauseStartTime;
  if(pauseDuration < 200) { // it is a click not a hold
    //if(!this.wasRecentlyPaused) return
    if(this.pauseResumeTime - lastResumeTime < 150) return
    if(event.target.closest('.nav-left')) this.previousStatus()
    if(event.target.closest('.nav-right')) this.nextStatus()
    return
  }
  
  // Resume audio if it was playing
  if (this.audioElement && this.hasAudio) {
    const playPromise = this.audioElement.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {
        this.isPlaying = true;
      }).catch(err => {
        console.error('Resume error:', err);
      });
    }
  } else if (!this.hasAudio) {
    // Resume auto progress for non-audio status
    this.elapsedTime += pauseDuration;
    this.remainingTime = (this.progressDuration * 1000) - this.elapsedTime;
    
    if (this.remainingTime > 0) {
      this.autoProgressTimer = setTimeout(() => {
        this.nextStatus();
      }, this.remainingTime);
    } else {
      this.nextStatus();
    }
  }
  
  // Prevent click event from firing for a short time
  setTimeout(() => {
    this.wasRecentlyPaused = false;
  }, 100);
},

pauseForMenu() {
  this.pauseStartTime = Date.now();
  
  if (this.autoProgressTimer) {
    clearTimeout(this.autoProgressTimer);
  }
  
  if (this.audioElement) {
    this.audioElement.pause();
  }
},

resumeFromMenu() {
  const pauseDuration = Date.now() - this.pauseStartTime;
  
  if (this.audioElement && this.hasAudio) {
    this.audioElement.play();
  } else if (!this.hasAudio) {
    this.elapsedTime += pauseDuration;
    this.remainingTime = (this.progressDuration * 1000) - this.elapsedTime;
    
    if (this.remainingTime > 0) {
      this.autoProgressTimer = setTimeout(() => {
        this.nextStatus();
      }, this.remainingTime);
    }
  }
},

  },
  beforeUnmount() {
    this.stopAudio();
    this.clearAutoProgress();
  },
  mounted() {
    console.log('Status Viewer loaded');
  }
}